module.exports = __webpack_public_path__ + "static/img/box_desc_title.f3420455.webp";